import { LoadableBackground, LoadableAfterPaint } from '@confluence/loadable';

export const ArchivedPageBanner = LoadableBackground({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ArchivedPageBanner" */ '../src/ArchivedPageBannerV2'
			)
		).ArchivedPageBanner,
});
export const ArchivedPageBannerAfterPaint = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ArchivedPageBanner" */ '../src/ArchivedPageBannerV2'
			)
		).ArchivedPageBanner,
});
